"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../../theme"));
const useStyles = (0, _styles.makeStyles)({
  mobileCalendar: {
    width: '100%',
    height: '100%',
    position: 'absolute'
  },
  datepickerHeaderFixed: {
    position: 'fixed',
    width: '100%',
    height: '193px'
  },
  actionsFixed: {
    position: 'fixed',
    width: '100%',
    height: '90px',
    bottom: 0,
    backgroundColor: '#FFF'
  },
  rootDatepickerMobile: {
    position: 'fixed',
    width: '100%',
    height: 'calc(100% - 297px)',
    top: '200px',
    overflowY: 'auto',
    [_theme.default.breakpoints.up('xs')]: {
      top: '200px',
      height: 'calc(100% - 300px)'
    },
    [_theme.default.breakpoints.up('md')]: {
      top: '210px',
      height: 'calc(100% - 310px)'
    }
  },
  datepickerHeader: {
    padding: _theme.default.spacing(2, 4),
    [_theme.default.breakpoints.up('xs')]: {
      'padding-left': '20px',
      'padding-right': '20px',
      paddingTop: _theme.default.typography.pxToRem(20),
      paddingBottom: '0'
    },
    [_theme.default.breakpoints.up('md')]: {
      'padding-left': '50px',
      'padding-right': '50px',
      paddingTop: _theme.default.typography.pxToRem(30),
      paddingBottom: '0'
    }
  },
  datepickerHeaderItem: {
    width: '100%'
  },
  datepickerHeaderFix: {
    position: 'fixed',
    width: '100%'
  },
  datepickerHeaderLabel: {
    marginBottom: '2px !important',
    color: '#FFF !important'
  },
  wrapDatepickerMobile: {
    position: 'relative',
    overflow: 'inherit !important',
    backgroundColor: '#FFFFFF',
    borderRadius: '0 !important',
    boxShadow: '0px 2px 4px 0 rgba(6,21,86,0.15)'
  },
  datepickerHeaderMobileBtn: {
    display: 'flex',
    'justify-content': 'flex-end'
  },
  mobileButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    paddingRight: _theme.default.typography.pxToRem(20),
    [_theme.default.breakpoints.down('md')]: {
      '& button': {
        height: '50px'
      }
    },
    [_theme.default.breakpoints.up('xs')]: {
      'padding-right': '20px',
      paddingTop: _theme.default.typography.pxToRem(20),
      paddingBottom: _theme.default.typography.pxToRem(20)
    },
    [_theme.default.breakpoints.up('md')]: {
      'padding-right': '50px',
      paddingTop: _theme.default.typography.pxToRem(25),
      paddingBottom: _theme.default.typography.pxToRem(25),
      '& button': {
        height: '40px'
      }
    }
  },
  mobileButtonsGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%'
  },
  resetButton: {
    textTransform: 'capitalize',
    color: _theme.default.palette.primary.light,
    letterSpacing: 'inherit',
    fontSize: _theme.default.typography.pxToRem(14),
    maxWidth: '104px'
  },
  doneButton: {
    minWidth: _theme.default.typography.pxToRem(104),
    width: 'auto',
    '&.MuiButton-containedPrimary': {
      marginLeft: '0'
    },
    [_theme.default.breakpoints.up('md')]: {
      minWidth: _theme.default.typography.pxToRem(95),
      maxHeight: '40px'
    },
    [_theme.default.breakpoints.down('sm')]: {
      fontSize: '18px !important'
    }
  },
  resetButtonMobile: {
    textTransform: 'capitalize',
    padding: '0 !important',
    color: _theme.default.palette.primary.light,
    letterSpacing: 'inherit',
    fontSize: '16px !important',
    width: 'auto',
    minWidth: '0',
    marginRight: _theme.default.typography.pxToRem(40),
    [_theme.default.breakpoints.up('md')]: {
      paddingTop: _theme.default.typography.pxToRem(25),
      paddingBottom: _theme.default.typography.pxToRem(25),
      maxHeight: '40px'
    }
  },
  datepickerMessages: {
    display: 'flex',
    justifyContent: 'flex-end',
    fontFamily: _theme.default.typography.proxima.regular,
    fontSize: '14px',
    lineHeight: '17px',
    padding: '20px 20px 20px 20px',
    color: _theme.default.palette.grayScale.dark,
    [_theme.default.breakpoints.up('xs')]: {
      padding: '20px 20px 20px 20px'
    },
    [_theme.default.breakpoints.up('md')]: {
      padding: '20px 50px 20px 50px'
    }
  },
  underscore: {
    width: _theme.default.typography.pxToRem(20),
    height: _theme.default.typography.pxToRem(3),
    background: '#061556',
    borderRadius: '10px',
    marginLeft: _theme.default.typography.pxToRem(7.5),
    marginRight: '8px',
    marginTop: '7px'
  },
  datepickerCalendar: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '30px'
  }
});
var _default = exports.default = useStyles;